import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SupportUserInterface } from '../../../models/support-user.interface';
import { ExtranetService } from '../../../services/extranet.service';
import { LinesService } from '../../../../lines/services/lines.service';
import { environment } from '../../../../../../environments/environment';
import { ChangeFinalBillingDateInterface } from '../../../models/change-final-billing-date.interface';

@Component({
    selector: 'app-change-final-billing-date',
    templateUrl: './change-final-billing-date.component.html',
    styleUrls: ['./change-final-billing-date.component.css'],
    standalone: false
})
export class ChangeFinalBillingDateComponent implements OnInit {

  @Input()
  selectedPhoneNumber: LineInterface;

  @Input()
  procedureCode: string;

  dateLoadError = false;
  endBillingDate: string = null;
  endBillingDateGroup: FormGroup;
  formSubmitted = false;
  showPlaceHolder = true;
  invalidDatePicked = false;
  supportUser: SupportUserInterface;
  initialTerminationDate: Date;
  brand?: string;

  constructor(
    private store: Store<any>,
    private lineService: LinesService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private extranetService: ExtranetService,
  ) {
  }

  ngOnInit() {
    this.brand = environment.data.brand;
    this.matIconRegistry.addSvgIcon(
      'agenda',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
      )
    );

    this.lineService.getInitalLineTerminationDate(this.selectedPhoneNumber.phoneNumber).subscribe((value) => {
      if (value === null) {
        this.dateLoadError = true;
      }
      this.initialTerminationDate = moment(value.date, 'DD/MM/YYYY hh:mm:ss').startOf('day').toDate();
    });
    this.supportUser = this.extranetService.getSupportUser();
    this.endBillingDateGroup = this.formBuilder.group({});
    this.endBillingDateGroup.addControl('endBillingDateControl', new FormControl('', [Validators.required]));
  }

  checkValidDates(): boolean {
    return this.dateRangeFilter(moment(this.endBillingDate).toDate());
  }

  confirmation() {
      if (this.endBillingDateGroup.controls.endBillingDateControl.valid && this.formSubmitted === false) {
        this.formSubmitted = true;
        if (this.checkValidDates()) {
        const changeFinalBillingDateObject = {
          phoneNumber: this.selectedPhoneNumber.phoneNumber,
          endBillingDate: moment(this.endBillingDate).format('YYYY-MM-DD'),
          initialEndBillingDate: moment(this.initialTerminationDate).format('YYYY-MM-DD'),
        } as ChangeFinalBillingDateInterface;
        this.store.dispatch(new SaveMission(changeFinalBillingDateObject, this.procedureCode));
      }
    } else {
        this.formSubmitted = false;
        this.invalidDatePicked = true;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setFinalBillingDate($event) {
    this.showPlaceHolder = false;
    this.endBillingDate = $event;
  }

  /**
   * Date range filter.
   * A regular user can pick from 10days starting initial termination date and up to 50 days after.
   * A support user can pick starting the current day + 1.
   * @param forDay Date iteration
   */
  dateRangeFilter = (forDay: Date | null): boolean => {
    return (this.supportUser ?
      moment(forDay).isAfter(moment()) :
      moment(forDay).isAfter(moment(this.initialTerminationDate).add(10, 'd'))
      )
      && moment(forDay).isBefore(moment(this.initialTerminationDate).add(60, 'd'))
    ;
  }
}
